import t from "./StateResults.vue_rollup-plugin-vue=script.js";
export default (function (t, e, s, r, n, a, o, u) {
  var i = ("function" == typeof s ? s.options : s) || {};
  return i.__file = "StateResults.vue", i.render || (i.render = t.render, i.staticRenderFns = t.staticRenderFns, i._compiled = !0, n && (i.functional = !0)), i._scopeId = r, i;
})({
  render: function render() {
    var t = this,
        e = t.$createElement,
        s = t._self._c || e;
    return t.state && t.state.state && t.state.results ? s("div", {
      class: t.suit()
    }, [t._t("default", function () {
      return [s("p", [t._v("\n      Use this component to have a different layout based on a certain state.\n    ")]), t._v(" "), s("p", [t._v("Fill in the slot, and get access to the following things:")]), t._v(" "), s("pre", [t._v("results: " + t._s(Object.keys(t.state.results)))]), t._v(" "), s("pre", [t._v("state: " + t._s(Object.keys(t.state.state)))]), t._v(" "), s("pre", [t._v("status: " + t._s(t.state.status))]), t._v(" "), s("pre", [t._v("error: " + t._s(t.state.error))])];
    }, null, t.stateResults)], 2) : t._e();
  },
  staticRenderFns: []
}, 0, t, void 0, !1);